<template>
    <icon-base v-bind="$props">
        <path d="M6 9l6 6l6 -6"></path>
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
